import { ColumnSpanConfig } from "../blocks/layout/GridColumn.types";
import { FieldConfig } from "./fieldConfig.types";

interface ContentConfigBase {
  /**
   * Its own discriminator, because `type` alone cannot separate the two unions - a text
   * field and a text block are both `type: "text"`.
   */
  kind: "content";
  /** Width within the section's own 12-column row, like a field's. */
  span?: ColumnSpanConfig;
  /** Shown only while this rule in `visibilityRules` holds. */
  visibleWhen?: string;
}

/**
 * Presentation-only items in a section, beside its fields. Not part of the FieldConfig
 * union, whose every member has a name the save path writes attributes by.
 */
export type ContentConfig =
  | (ContentConfigBase & { type: "text"; content: string })
  | (ContentConfigBase & { type: "divider" })
  | (ContentConfigBase & { type: "spacer"; height?: number });

export type ContentType = ContentConfig["type"];

export type SectionItemConfig = FieldConfig | ContentConfig;

export function isContentConfig(
  item: SectionItemConfig
): item is ContentConfig {
  return "kind" in item && item.kind === "content";
}

export const ContentLabels: Record<ContentType, string> = {
  text: "Text",
  divider: "Divider",
  spacer: "Spacer",
};

/** What to call an item that may have no label of its own. */
export function sectionItemLabel(item: SectionItemConfig) {
  return isContentConfig(item) ? ContentLabels[item.type] : item.label;
}

/** The record attribute an item reads and writes, or null for a content block. */
export function sectionItemName(item: SectionItemConfig) {
  return isContentConfig(item) ? null : item.name;
}
